export default __webpack_public_path__ + "media/images/icons_fc/clientsbleu-eb4d6b9e86b92f2abf10dd62e8e6480d.png";